module.exports = __webpack_public_path__ + "static/media/web.00e5c92e.config";